import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.mikoworld.de',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'mikoworld',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'mikospending',
});

export default keycloak;
